import { Component } from '@angular/core';
import { AuthService } from '@core/auth';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { AppLayoutComponent } from '@core/layout';
import { FunnyLoaderComponent } from '@shared/components/funny-loader/funny-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    AppLayoutComponent,
    CommonModule,
    RouterOutlet,
    NotificationsComponent,
    FunnyLoaderComponent
  ],
  template: `
    <div class="h-screen w-screen">
    <app-notifications />
    <app-funny-loader />
    <!-- Show Layout for authenticated routes -->
    <ng-container *ngIf="shouldShowLayout(); else publicContent">
      <app-layout></app-layout>
    </ng-container>

    <!-- Show direct content for public routes -->
    <ng-template #publicContent>
      <router-outlet></router-outlet>
    </ng-template>
    </div>
  `
})
export class AppComponent {
  constructor(private authService: AuthService) {}

  shouldShowLayout(): boolean {
    // Get the current path
    const path = window.location.pathname;

    // List of public routes that should be shown outside the layout
    const publicRoutes = ['/callback', '/login'];

    // Show layout only if authenticated and not on a public route
    return this.authService.isAuthenticated() &&
           !publicRoutes.some(route => path.startsWith(route));
  }
}
